import _ = require("underscore");
import Utils = require("../utils");
import Portal = require("portal-gis");
import Mediator = require("../mediator");
import MapView = require("../views/MapView");
import Templates = require("../models/defaults");
import SymbologyCollection = require("../collections/symbology-collection");
import ol = require("ol");

import ol3_symbolizer = require("./symbolizer/ol3");

const defaultOptions = {
    fillStyle: <Rhythm.Symbology.FillSymbol>{
        type: "sfs",
        style: "solid",
        color: [0, 0, 0, 1],
        outline: null
    },

    strokeStyle: <Rhythm.Symbology.LineSymbol>{
        type: "",
        style: "solid",
        color: [0, 0, 0, 1],
        width: 1
    },

    textStyle: <Rhythm.Symbology.TextSymbol>{
        type: "",
        style: "",
        color: [0, 0, 0, 1],
        size: 0,
        angle: 0,
        fill: null,
        stroke: null, // stroke and outline are duplicates, remove stroke
        outline: null,
        xoffset: 0,
        yoffset: 0,
        font: "bold 12 pt courier new",
        text: "",
        textAlign: "left",
        textBaseline: "bottom",
        scale: 1, // what does scale indicate? mysteriously started working and is a size multipler, 1 is good, 0 made text invisible
        rotation: 0
    },

    circleStyle: <Rhythm.Symbology.SimpleMarkerSymbol>{
        radius: 7,
        fill: null,
        outline: null
    }

};

// TODO: move to config
const defaultStyles = {
    "point": new ol.style.Style({
        fill: new ol.style.Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new ol.style.Stroke({
            color: '#ffcc33',
            width: 2
        }),
        image: new ol.style.Circle({
            radius: 7,
            fill: new ol.style.Fill({
                color: '#ffcc33'
            })
        })
    }),

    "line": new ol.style.Style({
        fill: new ol.style.Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new ol.style.Stroke({
            color: '#ffcc33',
            width: 2
        }),
        image: new ol.style.Circle({
            radius: 7,
            fill: new ol.style.Fill({
                color: '#ffcc33'
            })
        })
    }),

    "polygon": new ol.style.Style({
        fill: new ol.style.Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new ol.style.Stroke({
            color: '#ffcc33',
            width: 2
        }),
        image: new ol.style.Circle({
            radius: 7,
            fill: new ol.style.Fill({
                color: '#ffcc33'
            })
        })
    }),

    "multipoint": new ol.style.Style({
        fill: new ol.style.Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new ol.style.Stroke({
            color: '#ffcc33',
            width: 2
        }),
        image: new ol.style.Circle({
            radius: 7,
            fill: new ol.style.Fill({
                color: '#ffcc33'
            })
        })
    }),

    "multiline": new ol.style.Style({
        fill: new ol.style.Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new ol.style.Stroke({
            color: '#ffcc33',
            width: 2
        }),
        image: new ol.style.Circle({
            radius: 7,
            fill: new ol.style.Fill({
                color: '#ffcc33'
            })
        })
    }),

    "multipolygon": new ol.style.Style({
        fill: new ol.style.Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new ol.style.Stroke({
            color: '#ffcc33',
            width: 2
        }),
        image: new ol.style.Circle({
            radius: 7,
            fill: new ol.style.Fill({
                color: '#ffcc33'
            })
        })
    })
};

function createIconOptions(options: Rhythm.GIS.Dictionary<string>) {

    var iconOptions = <olx.style.IconOptions>{
        anchor: [0.5, 0.5],
        anchorOrigin: "top-left",
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        color: [0, 0, 0],
        offset: [0, 0],
        offsetOrigin: "top-left",
        opacity: 1,
        scale: 1,
        snapToPixel: false,
        rotateWithView: false,
        rotation: 0,
        src: requirejs.toUrl("app/icons/icon.png")
    };

    Object.keys(iconOptions).forEach(k => Utils.ifOption(options, k, v => iconOptions[k] = v));

    Utils.ifOption(options, "anchorXValue", anchorValue => iconOptions.anchor[0] = parseFloat(anchorValue));
    Utils.ifOption(options, "anchorYValue", anchorValue => iconOptions.anchor[1] = parseFloat(anchorValue));
    Utils.ifOption(options, "icon", icon => iconOptions.src = requirejs.toUrl(`app/icons/${icon}`));

    return iconOptions;
}

function findSymbol(symbols: SymbologyCollection, symbolRule = "*", attrs = {}) {
    return symbols.findSymbol(symbolRule, attrs);
}

function findStyle(featureInfo: Rhythm.GIS.FeatureQueryResultFeature, symbolIcon: Portal.MapIconConfigElement, options: any) {

    var style: ol.style.Style;

    switch (symbolIcon.type) {
        case "style": {
            let styleInfo = JSON.parse(symbolIcon.style);
            switch (styleInfo.type) {
                case "pms": {
                    // {"type":"pms","url":"02e14ed8eea3344324aa9654e8628896","imageData":"foo=encoded64","contentType":"image/png","width":19,"height":19,"angle":0,"xoffset":0,"yoffset":0}"

                    let iconOption = createIconOptions(options);
                    if (styleInfo.url) {
                        iconOption.src = styleInfo.url;
                    }
                    else if (styleInfo.imageData) {
                        iconOption.src = asImageData(styleInfo);
                    }
                    let icon = asIcon(iconOption);
                    style = new ol.style.Style({
                        image: icon
                    });
                    break;
                }
                case "sls": {
                    // {"type":"esriSLS","style":"esriSLSSolid","color":[0,115,76,255],"width":1}
                    let stroke = asStroke(styleInfo);
                    style = new ol.style.Style({ stroke: stroke });
                    break;
                }
                case "sfs": {
                    // {"type":"sfs","style":"esriSFSSolid","color":[246,197,103,255],"outline":{"type":"esriSLS","style":"esriSLSSolid","color":[0,0,0,255],"width":0.4}}
                    let stroke = asStroke(styleInfo.outline);
                    let fill = asFill(styleInfo);
                    style = new ol.style.Style({
                        fill: fill,
                        stroke: stroke
                    });
                    break;
                }
                case "circle": {
                    let circle = asCircle(styleInfo);
                    let text = styleInfo.text && asText(styleInfo.text);
                    if (text) {
                        text.setText(_.template(text.getText())(featureInfo ? featureInfo.attributes : {}));
                    }
                    style = new ol.style.Style({
                        image: circle,
                        text: text
                    });
                    break;
                }
                case "mixed": {
                    let stroke = styleInfo.outline && asStroke(styleInfo.outline);
                    let fill = styleInfo.fill && asFill(styleInfo.fill);
                    let image = styleInfo.image && asImage(styleInfo.image);
                    let text = styleInfo.text && asText(styleInfo.text);
                    let zIndex = styleInfo.zIndex;
                    if (text && featureInfo) {
                        text.setText(_.template(text.getText())(featureInfo ? featureInfo.attributes : {}));
                    }
                    style = new ol.style.Style({
                        fill: fill,
                        stroke: stroke,
                        image: image,
                        text: text
                    });
                    break;
                }

                case "sms": {
                    // {"style":"cross","color":[155,187,89,128],"outline":{"style":"solid","color":[115,140,61,255],"width":1,"type":"sls"},"type":"sms","size":18}
                    let stroke = styleInfo.outline && asStroke(styleInfo.outline);
                    let fill = asFill(styleInfo);
                    let size = styleInfo.size || 1;
                    let rotation = styleInfo.angle || 0;
                    switch (styleInfo.style) {
                        case "cross": {
                            style = new ol.style.Style({
                                image: new ol.style.RegularShape({
                                    fill: fill,
                                    stroke: stroke,
                                    points: 4,
                                    radius: size / 2,
                                    radius2: 0,
                                    angle: 0,
                                    rotation: rotation
                                })
                            });
                            break;
                        }
                        default: {
                            console.log("unhandled style type", styleInfo.type);
                        }
                    }
                    break;
                }

                case "icon": {
                    let iconOption = createIconOptions(options);
                    if (symbolIcon.style) {
                        iconOption.src = requirejs.toUrl(`app/icons/${symbolIcon.style}`);
                    }
                    let icon = asIcon(iconOption);
                    style = new ol.style.Style({
                        image: icon
                    });
                    break;
                }

                default: {
                    // legacy
                    if (!featureInfo || ((typeof featureInfo.geometryType == "undefined") || (featureInfo.geometryType === "point"))) {
                        let iconOption = createIconOptions(options);
                        iconOption.src = requirejs.toUrl(`app/icons/${symbolIcon.id}`);
                        let icon = asIcon(iconOption);
                        style = new ol.style.Style({
                            image: icon
                        });
                    } else {
                        // possible to add a marker to a non-point feature (without creating a second feature?)
                    }
                    break;
                }
            }
            return style;
        }
        default: {
            let styleText = symbolIcon.style;
            styleText = _.template(styleText)(featureInfo ? featureInfo.attributes : {});
            let styleInfo = JSON.parse(styleText);
            return styleInfo.map(styleInfo => ol3_symbolizer.fromJson(styleInfo));
        }
    }
}

function asImageData(symbol: Rhythm.Symbology.PictureSymbol) {
    var url = `data:${symbol.contentType};base64,${symbol.imageData}`;
    return `url(${url})`;
}

function asIcon(styleInfo: olx.style.IconOptions) {
    let icon = new ol.style.Icon(styleInfo);
    return icon;
}

function asColor(color: Rhythm.Symbology.Color) {
    if (!color) color = [0, 0, 0, 1]; // black

    if (typeof color === "string") {
        // do nothing
    } else {
        while (color.length < 3) color.push(0);
        if (color.length === 3) color.push(1);
        else if (color[3] > 1) color[3] /= 255;
    }
    return <any>color;
}

function asFill(styleInfo: Rhythm.Symbology.FillSymbol) {
    styleInfo = _.defaults(styleInfo || <any>{}, defaultOptions.fillStyle);

    let fill = new ol.style.Fill();
    if (styleInfo) {
        styleInfo.color && fill.setColor(asColor(styleInfo.color));
    }
    return fill;
}

function asStroke(styleInfo: Rhythm.Symbology.LineSymbol) {
    styleInfo = _.defaults(styleInfo || <any>{}, defaultOptions.strokeStyle);
    if (typeof styleInfo.width === "undefined") styleInfo.width = 1;
    if (typeof styleInfo.color === "undefined") styleInfo.color = [0, 0, 0, 1];
    styleInfo.lineCap = styleInfo.lineCap || "square";

    switch (styleInfo.style) {
        case "dot":
            styleInfo.lineDash = [1, 30];
            break;
        case "dash":
            styleInfo.lineDash = [3, 1];
            break;
        case "dashdot":
            styleInfo.lineDash = [5, 5, 1, 2];
            break;
        case "dashdotdot":
            styleInfo.lineDash = [5, 5, 1, 2, 1, 2];
            break;
        default:
            break;
    }

    //if (styleInfo.lineDash) styleInfo.lineDash = styleInfo.lineDash.map(v => v * 4);
    let stroke = new ol.style.Stroke(styleInfo);

    return stroke;
}

function asCircle(styleInfo: Rhythm.Symbology.SimpleMarkerSymbol) {
    styleInfo = _.defaults(styleInfo || <any>{}, defaultOptions.circleStyle);
    let fill = asFill(styleInfo.fill);
    let stroke = asStroke(styleInfo.outline);
    let circle = new ol.style.Circle({
        radius: styleInfo.radius | 7,
        fill: fill,
        stroke: stroke
    });
    return circle;
}

function asImage(styleInfo: Rhythm.Symbology.SimpleMarkerSymbol) {
    let result: ol.style.Image;
    if (styleInfo.icon) {
        let iconOption = createIconOptions(styleInfo);
        result = asIcon(iconOption);
    } else {
        result = asCircle(styleInfo);
    }
    return result;
}

function asText(styleInfo: Rhythm.Symbology.TextSymbol) {
    styleInfo = _.defaults(styleInfo || <any>{}, defaultOptions.textStyle);
    let options = <olx.style.TextOptions>{};
    options.fill = asFill(styleInfo.fill);
    options.font = styleInfo.font;
    options.offsetX = styleInfo.xoffset;
    options.offsetY = styleInfo.yoffset;
    options.rotation = styleInfo.rotation;
    options.scale = styleInfo.scale;
    options.stroke = asStroke(styleInfo.outline);
    options.text = styleInfo.text;
    options.textAlign = styleInfo.textAlign;
    options.textBaseline = styleInfo.textBaseline;
    return new ol.style.Text(options);
}

class Symbology {

    static about = `Finds and applies desired symbology to features.`;

    findSymbol(mediator: Mediator, featureInfo: Rhythm.GIS.FeatureQueryResultFeature, symbology?: string) {
        let symbols = mediator.api.symbology;
        if (!symbols) {
            console.warn("app symbology not defined");
            return null;
        }

        symbology = symbology || featureInfo.attributes["symbology"] || mediator.extend(featureInfo).symbology;
        if (!symbology) {
            let olFeature = Utils.extend(featureInfo).olFeature;
            symbology = olFeature && olFeature.get("symbology");
        }

        return findSymbol(symbols, symbology, featureInfo.attributes);
    }

    findStyle(mediator: Mediator, featureInfo: Rhythm.GIS.FeatureQueryResultFeature | string, defaultStyle = defaultStyles["point"]) {
        let symbols = mediator.api.symbology;

        let symbolIcon: Portal.MapIconConfigElement;

        if (typeof featureInfo === "string") {
            symbolIcon = findSymbol(symbols, featureInfo, {});
        } else {
            let symbology = featureInfo.attributes["symbology"] || mediator.extend(featureInfo).symbology;
            if (!symbology) {
                let olFeature = Utils.extend(featureInfo).olFeature;
                symbology = olFeature && olFeature.get("symbology");
            }

            symbolIcon = findSymbol(symbols, symbology, featureInfo.attributes);
        }

        return (symbolIcon && findStyle(typeof featureInfo === "string" ? null : featureInfo, symbolIcon, {})) || defaultStyle;
    }

    copyToMap(
        features: Array<Rhythm.GIS.FeatureQueryResultFeature>, // TODO: take a portal.feature instead of a 'normalized' feature
        view: MapView,
        vectorSource: ol.source.Vector,
        options: Rhythm.GIS.Dictionary<string>) {


        let mediator = view.mediator;
        let symbols = mediator.api.symbology;

        var sourceSrs = "EPSG:4326";
        var targetSrs = view.options.wkid;

        if (options["srs"] && options["srs"] !== sourceSrs) {
            console.warn(`BREAKING CHANGE: assuming features are in ${sourceSrs} not the requested ${options["srs"]}`);
        }

        return features.map(featureInfo => {
            var geom: ol.geom.SimpleGeometry;

            switch (featureInfo.geometryType || "point") {
                case "point":
                    geom = new ol.geom.Point(featureInfo.geometry);
                    break;
                case "line":
                    geom = new ol.geom.LineString(featureInfo.geometry);
                    break;
                case "polygon":
                    geom = new ol.geom.Polygon(featureInfo.geometry);
                    break;
                case "multipoint":
                    geom = new ol.geom.MultiPoint(featureInfo.geometry);
                    break;
                case "multiline":
                    geom = new ol.geom.MultiLineString(featureInfo.geometry);
                    break;
                case "multipolygon":
                    geom = new ol.geom.MultiPolygon(featureInfo.geometry);
                    break;
                default:
                    break;
            }

            if (!geom) {
                console.warn("no geometry found");
                return;
            }

            geom = <ol.geom.SimpleGeometry>geom.transform(sourceSrs, targetSrs);

            let label = "TODO TITLE";
            let style = <ol.style.Style>(defaultStyles[featureInfo.geometryType] || defaultStyles["point"]);

            /**
             * Unbelievably I still cannot access the symbology in all cases...all references to symbology need to be reconsidered before anyone
             * else can possibly develop against this framework...horrible!
             * Sometimes it uses mediator.extend, other times Utils.extend, sometimes on the feature sometimes the featureInfo
             * Not to mention there is the configuration feature, the model feature and the map feature...toooooo much cruft.
             */
            let symbology = Utils.extend(featureInfo).symbology || options["symbology"];
            if (symbology) {
                Utils.extend(featureInfo, { symbology: symbology });
                mediator.extend(featureInfo, { symbology: symbology });
            }
            let symbolIcon = findSymbol(symbols, symbology, featureInfo.attributes);

            if (symbolIcon) {
                label = symbolIcon.Label;
                style = findStyle(featureInfo, symbolIcon, options) || style;
            }

            let feature = new ol.Feature({
                geometry: geom,
                name: label,
                attributes: featureInfo.attributes
            });

            // ensure the olFeature extension is identical to the featureInfo extension (why?)
            mediator.extensions.bind(feature, featureInfo);

            // for unit testing purposes it's useful to know what symbology was ultimately assigned
            mediator.extensions.extend(feature, {
                "symbol-icon": symbolIcon
            });

            mediator.mapViewMap(map => {
                feature.setStyle((resolution: number) => {
                    featureInfo.attributes["zoom"] = map.getView().getZoom() + "";
                    featureInfo.attributes["geometryType"] = feature.getGeometry().getType();
                    return this.findStyle(mediator, featureInfo, style);
                });
            });

            vectorSource.addFeature(feature);

            // connect feature instance to its definition
            mediator.extend(featureInfo, {
                olFeature: feature
            });
            mediator.extend(feature, {
                model: featureInfo
            });

            return feature;

        });

    }

    asStyle(icon: Portal.MapIconConfigElement) {
        return findStyle(null, icon, null);
    }

}


let s = new Symbology();

export = s;
